import React, { useContext, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import { Button, FloatButton, Form, message, Typography, Upload, UploadProps, Segmented, Alert } from "antd";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import Editor from "@monaco-editor/react";
import UseWebSocketSubscription from "../../../UseWebSocketSubscription";
import { InboxOutlined } from "@mui/icons-material";
import { motion } from "framer-motion";
import { GetJutgeProblemesId } from "../../../../dao/jutge/GetJutgeProblemesId";
import { GetJutgeProblemesIdRanking } from "../../../../dao/jutge/GetJutgeProblemesIdRanking";
import { PostJutgeProblemaIdUsuariId } from "../../../../dao/jutge/PostJutgeProblemaIdUsuariId";
import { PostJutgeProblemaIdUsuariIdMulti } from "../../../../dao/jutge/PostJutgeProblemaIdUsuariIdMulti";
import { DeleteJutgeFile } from "../../../../dao/jutge/DeleteJutgeFile";
import JavaMon from "./JavaMon";
import { IoOptions } from "react-icons/io5";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import { BiGame, BiCode, BiTrophy } from "react-icons/bi";
import { GetJutgeUsuariIdPoints } from "../../../../dao/jutge/GetJutgeUsuariIdPoints";
import { GetUsuariIdJutgeActivitatsId } from "../../../../dao/GetUsuariIdJutgeActivitatsId";

const { Title } = Typography;

interface Props {
    propIdProblema?: string;
    propIdActivitat?: string;
    readOnly?: boolean;
    isIdeExamFrame?: boolean;
    onSubmitSuccess?: () => void;
}
interface RankingItem {
    moment: string | null;
    position: string;
    id_usuari: string;
    nom: string;
    puntos: number;
    color: string;
}

const ProblemaIdEnunciat: React.FC<Props> = ({ propIdProblema, propIdActivitat, readOnly, isIdeExamFrame, onSubmitSuccess }) => {
    const { isLoggedIn, userId, user, alumne } = useContext(AuthContext);
    const params = useParams();
    const id_problema = propIdProblema || params.id_problema;
    const id_activitat = propIdActivitat || params.id_activitat;
    const [dades, setDades] = useState<any>();
    const [ranking, setRanking] = useState<RankingItem[]>([]);
    const [mode, setMode] = useState<'upload' | 'editor' | 'theia'>('upload');
    const [theiaUrl, setTheiaUrl] = useState('http://localhost:3030');
    const [showTheiaConfig, setShowTheiaConfig] = useState(false);
    const [selectedUid, setSelectedUid] = useState('');
    const [selectedUids, setSelectedUids] = useState<string[]>([]);
    const [enviado, setEnviado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isExam, setIsExam] = useState(false);
    const [editorValue, setEditorValue] = useState<string>("");
    const [showJavamon, setShowJavamon] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);
    const [checkResults, setCheckResults] = useState<any>();
    const [hintStatus, setHintStatus] = useState<any>(null);
    const [candadoJavamonActivo, setCandadoJavamonActivo] = useState(false);
    const [testJavamonActivo, setTestJavamonActivo] = useState(false);
    const initCalledRef = React.useRef(false);

    useEffect(() => {
        if (isIdeExamFrame) {
            setMode('theia');
        }
    }, [isIdeExamFrame]);



    const expiry = localStorage.getItem('incense_expiry');
    const isIncenseActive = expiry ? parseInt(expiry) > Date.now() : false;
    const probability = (110 - (dades?.javamons || 100)) + (isIncenseActive ? 10 : 0);

    const { Dragger } = Upload;

    useEffect(() => {
        if (isLoggedIn) {
            initCalledRef.current = false; // reset per problem
            fetchData();
        }
    }, [id_problema]);

    async function fetchData() {
        setLoading(true);
        const data = await GetJutgeProblemesId(id_problema + "", id_activitat || "0");
        //setIsExam(data.isExam === 1);
        setDades(data);

        const modoDesafio = (user as any)?.modoDesafio === 1 || (user as any)?.modoDesafio === true;
        // El init inicial registra el tiempo de inicio. El origen definitivo se machaca en el momento del envío.
        // Aquí usamos el contexto actual solo como primer registro. Si venimos del juego (fromGame), UNITY.
        const fromGameInit = typeof window !== "undefined" && window.location.search.includes("fromGame=true");
        const origen = fromGameInit ? "UNITY" : (isIdeExamFrame ? "WEB_DESAFIO" : (modoDesafio ? "WEB_DESAFIO" : "WEB_NORMAL"));
        if (!initCalledRef.current) {
            initCalledRef.current = true;
            if (!readOnly) {
                try {
                    await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost'}:8061/jutge/enviament/init`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                        },
                        body: JSON.stringify({
                            id_problema: id_problema + "",
                            id_activitat: id_activitat + "",
                            id_usuari: userId + "",
                            origen: origen
                        })
                    });
                } catch (e) { }
            }
        }

        setEditorValue(`import java.util.*;
// Examen de: ${data?.alumne?.nom ?? ""} ${data?.alumne?.cognoms ?? ""}
public class ${data?.nom ?? "Examen"} {
    public static void main(String[] args) {
        // Escribe aquí tu código
    }
}`);

        if (id_activitat && id_activitat !== "0") {
            try {
                const userActdata = await GetUsuariIdJutgeActivitatsId(userId + "", id_activitat);
                const problemData = userActdata?.find((p: any) => p.id === Number(id_problema));

                if (problemData) {
                    if (problemData.progres >= 1) {
                        setIsCorrect(true);
                    }
                    if (problemData.origen_success !== undefined && problemData.origen_success !== null) {
                        setDades((prev: any) => ({ ...prev, origen_success: problemData.origen_success }));
                    }
                    if (Array.isArray(problemData.trofeus)) {
                        const mappedRanking = problemData.trofeus
                            .map((t: any) => ({
                                moment: null,
                                position: t.nom,
                                id_usuari: '',
                                nom: t.claimed === 1 ? t.winner : 'Disponible',
                                puntos: t.punts || t.puntos || 0,
                                color: t.color || '#ccc',
                                claimed: t.claimed
                            }));
                        setRanking(mappedRanking);
                    } else {
                        setRanking([]);
                    }
                } else {
                    setRanking([]);
                }
            } catch (error) {
                console.error("Error fetching ranking from activity", error);
                setRanking([]);
            }
        } else {
            setRanking([]);
        }
        setLoading(false);
    }

    UseWebSocketSubscription(
        [`/topic/activitat/${id_activitat}/problema/${id_problema}`],
        async (topic: any, msg: any) => {
            if (msg === true || msg.accion === "REFRESH") {
                await fetchData();
            }
        }
    );

    const handleRecalculateRanking = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${process.env.REACT_APP_API_URL}:8061/jutge/activitats/${id_activitat}/problemes/${id_problema}/recalculate-ranking`, {
                method: 'POST',
            });
            if (response.ok) {
                message.success("Ranking recalculado correctamente.");
                await fetchData();
            } else {
                message.error("Error al recalcular el ranking.");
            }
        } catch (error) {
            message.error("Error de conexión al recalcular el ranking.");
        } finally {
            setLoading(false);
        }
    };

    const uploadProps: UploadProps = {
        name: 'file',
        multiple: dades?.multi === 1,
        beforeUpload: (file) => {
            if (file.name.toLowerCase().includes("test")) {
                message.error("El nombre del archivo no puede contener la palabra 'test'.");
                return Upload.LIST_IGNORE;
            }
            return true;
        },
        onRemove: async (file) => {
            const currentUid = (file as any).uid;
            // Remove from state only if user cancels an already uploaded file
            // But we actually want to delete from server too if it was successfully uploaded
            // The file object has 'status' = 'done' if uploaded? Antd handles this.
            // If it's just removed from list before upload finishes (or fails), maybe we don't need server call?
            // Safer to just try delete if we have the UID.

            // Also remove from selectedUids / selectedUid state
            if (dades?.multi === 1) {
                setSelectedUids(prev => prev.filter(uid => uid !== currentUid));
            } else {
                if (selectedUid === currentUid) setSelectedUid('');
            }

            // Call backend to delete
            await DeleteJutgeFile(id_problema + "", userId + "", currentUid, id_activitat || "0");
            return true;
        },
        onDrop(e) {
            // Drop logic handled by customRequest/onChange implicitly for accumulation if needed,
            // but Dragger internals handle file list. We focus on tracking UIDs from successful uploads.
            // On simple drop, we might just get the file object.
        },
        customRequest({ file, onSuccess, onError }) {
            const formData = new FormData();
            formData.append('file', file);

            // For multi, we probably generate a uid per file or let backend handle it?
            // Existing logic sends 'selectedUid' which is state. Ideally we generate one or let backend return it.
            // But current endpoint takes 'uid' param. Let's generate one or use file.uid if standard.
            // Actually existing code: formData.append('uid', selectedUid);
            // AND 'selectedUid' was set in onDrop... wait, onDrop runs before customRequest? Not reliably.
            // The existing implementation relies on onDrop setting selectedUid from e.dataTransfer.files[0].uid
            // which is a bit fragile if onDrop doesn't fire for click-upload.

            // BETTER: Use the rc-upload file.uid
            const currentUid = (file as any).uid;

            formData.append('uid', currentUid);

            return fetch(`${process.env.REACT_APP_API_URL}:8061/jutge/activitats/${id_activitat || "0"}/problemes/${id_problema}/usuaris/${userId}/upload`, {
                method: 'POST',
                body: formData,
            })
                .then(response => {
                    if (response.ok) {
                        onSuccess && onSuccess(file);
                        // Update state
                        if (dades?.multi === 1) {
                            setSelectedUids(prev => [...prev, currentUid]);
                        } else {
                            setSelectedUid(currentUid);
                        }
                    }
                })
                .catch(error => {
                    if (onError) onError(error);
                });
        }
    };

    async function submitData() {
        // El origen es determinat AQUÍ, en el moment de l'enviament real:
        // - UNITY: enviat des del joc Unity (l'IDE s'obre amb ?fromGame=true a la URL)
        // - WEB_DESAFIO: enviat des de l'IDE web (IdeExamFrameV2) fora del joc
        // - WEB_NORMAL: enviat des de la web normal
        // Això sobreescriu qualsevol init_enviament previ al SP post_enviament.
        const fromGame = typeof window !== "undefined" && window.location.search.includes("fromGame=true");
        const submitOrigen = fromGame ? "UNITY" : (isIdeExamFrame ? "WEB_DESAFIO" : "WEB_NORMAL");

        if (mode === 'theia') {
            setLoading(true);
            setEnviado(true);
            try {
                const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${baseUrl}:8061/jutge/ide/submit`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        idProblema: id_problema,
                        idAct: id_activitat || '0',
                        idUsuari: userId,
                        origen: submitOrigen
                    })
                });

                if (!response.ok) {
                    const data = await response.json();
                    // If it's HTML error (500), try to parse text?
                    throw new Error(data.response || data.error || data.message || "Error submission from IDE");
                }

                // response body is the result of postFilesMulti (evaluation result)
                const result = await response.json();

                if (result?.response === 'OK') {
                    message.success("TEST OK (Desde IDE)");
                    setConsoleOutput("");
                    setIsCorrect(true);
                    // Rewards are now handled externally
                } else {
                    message.error("Error en el envío. Revisa la consola.");
                    setConsoleOutput(result?.response || "Error desconocido");
                    // Can't mark errors in Monaco since we are in Theia mode, but we show console.
                }

            } catch (error: any) {
                message.error(error.message || "Error al enviar desde IDE.");
                setConsoleOutput(error.message);
            } finally {
                setLoading(false);
                setEnviado(false);
                onSubmitSuccess?.();
            }
            return;
        }

        setLoading(true);
        setEnviado(true);

        let currentSelectedUid = selectedUid;
        let currentSelectedUids = [...selectedUids];

        if (mode === 'editor') {
            try {
                const fileName = `${dades?.nom ?? "Main"}.java`;
                const file = new File([editorValue], fileName, { type: "text/x-java-source" });
                const editorUid = `editor-${Date.now()}`;

                const formData = new FormData();
                formData.append('file', file);
                formData.append('uid', editorUid);

                const response = await fetch(`${process.env.REACT_APP_API_URL}:8061/jutge/activitats/${id_activitat || "0"}/problemes/${id_problema}/usuaris/${userId}/upload`, {
                    method: 'POST',
                    body: formData,
                });

                if (!response.ok) throw new Error("Upload failed");

                currentSelectedUid = editorUid;
                currentSelectedUids = [editorUid];
            } catch (error) {
                message.error("Error al subir el código del editor.");
                setLoading(false);
                setEnviado(false);
                return;
            }
        }

        let response;
        if (dades?.multi === 1) {
            response = await PostJutgeProblemaIdUsuariIdMulti(id_problema + "", userId + "", currentSelectedUids, id_activitat || '0', submitOrigen);
        } else {
            response = await PostJutgeProblemaIdUsuariId(id_problema + "", userId + "", currentSelectedUid, id_activitat || '0', submitOrigen);
        }

        if (response?.response === 'OK') {
            message.success("TEST OK");
            // Clear selections after success
            setSelectedUid('');
            setSelectedUids([]);
            setConsoleOutput("");
            setIsCorrect(true);

            if (editorRef.current) {
                const model = editorRef.current.getModel();
                const monaco = (window as any).monaco;
                if (model && monaco) monaco.editor.setModelMarkers(model, "owner", []);
            }

            // Rewards are handled in Activitats.tsx
        } else {
            message.error("Error en el envío. Revisa la consola.");
            const errorText = response?.response === "Incorrect" ? "Tests failed. Revisa el listado de tests." : (response?.response || "Error desconocido");
            setConsoleOutput(errorText);
            parseAndMarkErrors(errorText);
        }
        setLoading(false);
        setEnviado(false);
        onSubmitSuccess?.();
    }

    const editorRef = React.useRef<any>(null);
    const [consoleOutput, setConsoleOutput] = useState<string>("");

    // Watch for mode change to 'theia'
    useEffect(() => {
        if (mode === 'theia') {
            const fetchTheiaUrl = async () => {
                const hide = message.loading("Aprovisionando tu entorno IDE personal...", 0);
                try {
                    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';

                    // Add id_problema to request context
                    const urlFetch = `${baseUrl}:8061/jutge/theia/port?id_usuari=${userId}&id_problema=${id_problema}`;
                    console.log("Fetching Theia Url:", urlFetch);

                    const token = localStorage.getItem('authToken');

                    const response = await fetch(urlFetch, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    if (response.status === 202) {
                        setTimeout(fetchTheiaUrl, 3000);
                        return;
                    }

                    const contentType = response.headers.get("content-type");
                    if (contentType && contentType.indexOf("application/json") === -1) {
                        const text = await response.text();
                        console.error("Non-JSON Response received:", text);
                        throw new Error("El servidor devolvió HTML en lugar de JSON. URL incorrecta o sesión expirada.");
                    }

                    if (!response.ok) throw new Error("Error connecting to backend");

                    const data = await response.json();

                    if (data.error) throw new Error(data.error);
                    if (data.status === 'provisioning') {
                        setTimeout(fetchTheiaUrl, 3000);
                        return;
                    }

                    const hostname = data.hostname || window.location.hostname;

                    // Force HTTP for now as requested (to avoid mixed content and enable IP access)
                    let url = `http://${hostname}:${data.port}`;

                    // Add specific project folder path if available
                    // Use normalized name from backend if present, otherwise fallback to dades.nom (but might be risky if special chars)
                    const projectName = data.normalizedProjectName || (dades?.nom ? dades.nom.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '') : '');

                    if (projectName) {
                        url = `${url}/#/root/projects/${projectName}`;
                    } else {
                        url = `${url}/#/root/projects`;
                    }

                    setTheiaUrl(url);
                    message.success("¡IDE Listo!");

                } catch (error) {
                    console.error(error);
                    message.error("Error: " + (error as any).message);
                } finally {
                    hide();
                }
            };
            fetchTheiaUrl();
        }
    }, [mode, userId]);

    // Heartbeat mechanism for embedded IDE
    useEffect(() => {
        if (mode !== 'theia' || !theiaUrl) return;

        const sendHeartbeat = async () => {
            try {
                const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';
                const token = localStorage.getItem('authToken');

                // Only send if url implies we successfully got a container (not localhost:3030 default)
                if (theiaUrl === 'http://localhost:3030') return;

                await fetch(`${baseUrl}:8061/jutge/ide/heartbeat?id_usuari=${userId}`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${token}` }
                });
            } catch (e) {
                console.error("Heartbeat failed", e);
            }
        };

        sendHeartbeat();
        const interval = setInterval(sendHeartbeat, 60000); // 1 minute
        return () => clearInterval(interval);
    }, [mode, theiaUrl, userId]);


    function handleEditorDidMount(editor: any, monaco: any) {
        editorRef.current = editor;
    }

    const parseAndMarkErrors = (errorMsg: string) => {
        if (!editorRef.current) return;

        const model = editorRef.current.getModel();
        const monaco = (window as any).monaco;

        if (!model || !monaco) return;

        const markers: any[] = [];
        // Regex para capturar errores de Java tipo: /path/to/File.java:10: error: ...
        // O simplemente: line 10: ...
        // Ajusta segun el formato exacto que devuelve tu backend
        const lineRegex = /:(\d+):/g;

        let match;
        while ((match = lineRegex.exec(errorMsg)) !== null) {
            const line = parseInt(match[1]);
            markers.push({
                startLineNumber: line,
                startColumn: 1,
                endLineNumber: line,
                endColumn: 1000,
                message: errorMsg,
                severity: monaco.MarkerSeverity.Error
            });
        }

        monaco.editor.setModelMarkers(model, "owner", markers);
    };

    const renderPodium = () => {
        if (!id_activitat || id_activitat === "0") return null;
        if (!Array.isArray(ranking) || ranking.length === 0) return null;
        if (alumne?.alumne?.repetidor) return null;

        // El podium solo aplica si la solución se ha hecho en Modo Desafío (1) o en el juego (2)
        const isDesafioOrGame = dades?.origen_success === 1 || dades?.origen_success === 2 ||
                                dades?.origen_success === "1" || dades?.origen_success === "2";
        if (!isDesafioOrGame) return null;

        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                gap: "16px",
                marginBottom: "24px",
                minHeight: "150px"
            }}>
                {ranking.map((r, idx) => (
                    <motion.div
                        key={`${r.position}-${idx}`}
                        initial={{ y: 50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.5, delay: idx * 0.2 }}
                        style={{
                            backgroundColor: r.color ?? "#ccc",
                            width: 120,
                            height: 120,
                            borderRadius: "12px 12px 0 0",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            padding: "8px",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                            opacity: (r as any).claimed === 1 ? 1 : 0.6
                        }}
                    >
                        <div style={{ fontWeight: "bold", textAlign: "center", fontSize: (r as any).claimed !== 1 ? '0.85rem' : '1rem' }}>{r.nom}</div>
                        <div style={{ fontWeight: "bold", textAlign: "center", marginTop: "2px" }}>{r.puntos} pts</div>
                        <div style={{ fontSize: "0.7rem", color: "#333", marginTop: "2px" }}>{r.position}</div>
                    </motion.div>
                ))}
            </div>
        );
    };

    return (
        <>
            {renderPodium()}

            <h3>{dades?.nom}</h3>
            <br />
            <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                {dades?.descripcio}
            </ReactMarkdown>
            <hr />

            {!readOnly && (
                isCorrect ? (
                    <div style={{ margin: '20px 0' }}>
                        <Alert
                            message="¡Ejercicio completado!"
                            description="Has superado todos los tests correctamente para este ejercicio. No es necesario realizar más entregas."
                            type="success"
                            showIcon
                        />
                    </div>
                ) : (
                    <Form onFinish={submitData}>
                        {dades ? (
                            <>
                                {!isIdeExamFrame && (
                                    <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'center' }}>
                                        <Segmented
                                            options={[
                                                { label: 'Subir Archivo', value: 'upload', icon: <InboxOutlined /> },
                                                ...((alumne?.alumne?.ide === 1) ? [{ label: 'IDE JAVA', value: 'theia', icon: <BiCode /> }] : [])
                                            ]}
                                            value={mode}
                                            onChange={(val) => setMode(val as 'upload' | 'editor' | 'theia')}
                                        />
                                    </div>
                                )}

                                {mode === 'upload' && !isIdeExamFrame ? (
                                    <Form.Item name="file" rules={[{ required: true, message: 'Sube un archivo!' }]}>
                                        <Dragger {...uploadProps}>
                                            <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                                            <p className="ant-upload-text">
                                                {dades?.multi === 1
                                                    ? "Click o arrastra tus archivos '.java' (Uno debe contener el MAIN)"
                                                    : "Click o arrastra un archivo '.java'"}
                                            </p>
                                            <p className="ant-upload-hint">
                                                {dades?.multi === 1
                                                    ? "Puedes subir múltiples archivos."
                                                    : "Solo se permite un archivo."}
                                            </p>
                                        </Dragger>
                                    </Form.Item>
                                ) : mode === 'theia' && !isIdeExamFrame ? (
                                    <div style={{
                                        height: '300px',
                                        border: '1px solid #d9d9d9',
                                        borderRadius: 8,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#f9f9f9'
                                    }}>
                                        <Typography.Title level={4}>Entorno de Desarrollo Personal (IDE)</Typography.Title>
                                        <Typography.Paragraph type="secondary" style={{ maxWidth: 500, textAlign: 'center' }}>
                                            Tu entorno se ha aprovisionado correctamente.
                                            Debido a restricciones de seguridad del navegador, el IDE debe abrirse en una ventana separada.
                                        </Typography.Paragraph>

                                        <div style={{ display: 'flex', gap: 16 }}>
                                            <Button
                                                type="primary"
                                                size="large"
                                                icon={<BiCode />}
                                                onClick={() => window.open(theiaUrl, '_blank')}
                                                disabled={!theiaUrl || theiaUrl.includes('localhost:3030')}
                                            >
                                                {(!theiaUrl || theiaUrl.includes('localhost:3030')) ? 'Iniciando...' : 'Abrir IDE en Nueva Pestaña'}
                                            </Button>

                                            <Button
                                                size="large"
                                                onClick={() => {
                                                    setTheiaUrl(''); // Force re-fetch
                                                    window.location.reload();
                                                }}
                                            >
                                                Recargar Página
                                            </Button>
                                        </div>
                                        <div style={{ marginTop: 24, padding: 10, backgroundColor: "#fff5f5" }}>
                                            <Typography.Text type="warning">
                                                Una vez guardes tus archivos en el IDE, pulsa en "Enviar" abajo para evaluar.
                                            </Typography.Text>
                                        </div>

                                        <Typography.Text type="secondary" style={{ marginTop: 24, fontSize: 12 }}>
                                            URL Destino: {theiaUrl}
                                        </Typography.Text>
                                    </div>
                                ) : !isIdeExamFrame ? (
                                    <Form.Item name="editor" rules={[{ required: false }]}>
                                        <Editor
                                            height="400px"
                                            defaultLanguage="java"
                                            theme="light"
                                            value={editorValue}
                                            onChange={(val) => setEditorValue(val ?? "")}
                                            onMount={handleEditorDidMount}
                                            options={{ automaticLayout: true }}
                                        />
                                    </Form.Item>
                                ) : null}
                            </>
                        ) : !isIdeExamFrame ? (
                            <Form.Item name="editor_fallback" rules={[{ required: true, message: 'Escribe tu código!' }]}>
                                <Editor
                                    height="400px"
                                    defaultLanguage="java"
                                    theme="light"
                                    value={editorValue}
                                    onChange={(val) => setEditorValue(val ?? "")}
                                    onMount={handleEditorDidMount}
                                    options={{ automaticLayout: true }}
                                />
                            </Form.Item>
                        ) : null}

                        {consoleOutput && (
                            <div style={{ marginTop: 10, padding: 10, background: '#f5f5f5', border: '1px solid #d9d9d9', borderRadius: 4 }}>
                                <Typography.Text strong>Consola / Errores:</Typography.Text>
                                <pre style={{ color: 'red', marginTop: 5, whiteSpace: 'pre-wrap', maxHeight: '200px', overflow: 'auto' }}>
                                    {consoleOutput}
                                </pre>
                            </div>
                        )}

                        <hr />

                        {!isCorrect && (
                            <Form.Item>
                                <Button type="primary" htmlType="submit" loading={enviado} disabled={enviado}>
                                    Enviar {mode === 'theia' ? '(Desde IDE)' : ''}
                                </Button>
                            </Form.Item>
                        )}
                    </Form >
                )
            )}

            {/* Bloqueado para que solo aparezcan javamons si la recompensa del modo desafío lo indica */}
            {/* {showJavamon && <JavaMon onClose={() => setShowJavamon(false)} userId={userId} idSeason={dades?.id_season} />} */}

            {
                !loading && id_activitat && id_activitat !== "0" && (user.tipus === "0" || user.tipus === "1" ||
                    window.location.hostname.includes("localhost")) && alumne.alumne.isjavamon ? (
                    <FloatButton.Group
                        trigger="click"
                        type="primary"
                        style={{ insetInlineStart: 97 }}
                        icon={<IoOptions />}
                    >
                        {/* <FloatButton
                            shape="circle"
                            tooltip={`Simular Javamon (${isIncenseActive ? 'Incienso ACTIVO: ' : ''}${probability}%)`}
                            onClick={() => setShowJavamon(true)}
                            style={{ backgroundColor: AvaluacioColors.colors.color6 }}
                            icon={<BiGame />}
                        /> */}
                        {(user.tipus === "0" || user.tipus === "1") && (
                            <FloatButton
                                shape="circle"
                                tooltip="Recalcular trofeos"
                                onClick={handleRecalculateRanking}
                                style={{ backgroundColor: AvaluacioColors.colors.color3 }}
                                icon={<BiTrophy />}
                            />
                        )}
                    </FloatButton.Group>
                ) : <></>
            }

        </>
    );
};

export default ProblemaIdEnunciat;
